import React, { useEffect } from 'react';
import * as R from 'ramda';
import { composePS } from '@cd/pipe';
import { useHistory } from 'react-router';
import styles from '../css/Register.module.scss';
import { postJSONPS } from '../../lib/utils/fetch';
import { either } from '../../lib/utils/utils';
import Form from '../../dynamic/components/form/components/Form';

import { FORGOT_PWD_FORM } from '../../lib/utils/formFields';
import { useForm } from '../../dynamic/components/form/components/formUtils';
import withAlert from './withAlert';

const postGetForgotPasswordInfo = () =>
	composePS(postJSONPS)('POST', `/getForgotPasswordInfo`, {
		body: JSON.stringify({})
	});

const postGetSecurityQ = data =>
	composePS(postJSONPS)('POST', `/getSecurityQuestions`, {
		body: JSON.stringify({ data })
	});

const ForgotPassword = withAlert(({ onOpenAlertDlg }) => {
	const history = useHistory();
	const {
		data,
		onUpdateData,
		showPassword,
		onShowPassword,
		onSave: formOnSave,
		touched,
		validation,
		preProcessData,
		updateInitData
	} = useForm({ joiValidationSchema: FORGOT_PWD_FORM });

	useEffect(() => {
		composePS(updateInitData, preProcessData, postGetForgotPasswordInfo)();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onBackToLogin = () => {
		history.push('/login');
	};

	const onSave = () => {
		postGetSecurityQ(data).then(
			either(
				e =>
					onOpenAlertDlg({
						message: R.is(String, e) ? e : JSON.stringify(e),
						title: 'Error'
					}),
				secQuestionData => {
					formOnSave();
					const { email, bookNo } = data;
					history.push('/recoverPassword', {
						data: secQuestionData,
						email,
						bookNo
					});
				}
			)
		);
	};

	return (
		<div className={styles.wrap} style={{ marginTop: '128px' }}>
			<Form
				alwaysTouched
				formTitle="RECOVER PASSWORD"
				formFields={FORGOT_PWD_FORM}
				data={data}
				onUpdateData={onUpdateData}
				showPassword={showPassword}
				onShowPassword={onShowPassword}
				onSave={onSave}
				onCancel={onBackToLogin}
				validation={validation}
				editing={true}
				touched={touched}
				buttonLabels={['GET SECURITY QUESTIONS', 'LOGIN']}
				buttonIcons={['save', 'keyboard_backspace']}
			/>
		</div>
	);
});

export default ForgotPassword;
